<template>
    <div style="position: relative;" :class="!endAnimate ? 'on_bg_cl' : ''">
        <!-- <div v-if="complete" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.3); z-index: 10;"></div> -->
        <div v-if="!endAnimate" style="display: flex; position: relative; justify-content: center; height: 100%; align-items: center;">
            <div style="width: 200px; height: 200px; position: relative; display: flex; justify-content: center; align-items: center;">
                <div :class="showContents ? 'show_contents_text' : 'un_show_contents_text'" style="position: absolute; top: -200px; font-weight: 700; font-size: 32px; color: #ffa011; width: 390px; text-align: center;">포지션 찾기 lite</div>
                <img :src="stepStatus === 5 ? require('@/assets/img/ground_2.png') : require('@/assets/img/animate_ground.png')" :class="[{ step1: stepStatus === 1 }, { step2: stepStatus === 2 }, { step3: stepStatus === 3 }, { step4: stepStatus === 4 }, { step5: stepStatus === 5 }, { show_contents: showContents }]">
                <img :src="require('@/assets/img/soccer_ball.png')" :class="[{ step1_ball: stepStatus === 1 }, { step2_ball: stepStatus === 2 }, { step3_ball: stepStatus === 3 }, { step4_ball: stepStatus === 4 }, { step_end_ball: stepStatus === 5 }]" style="position: absolute; " alt="">
                <div class="step1_circle" :class="[{ step1_ani1: stepStatus === 1 }, { step2_ani1: stepStatus === 2 }, { step3_ani1: stepStatus === 3 }, { step4_ani1: stepStatus === 4 }, { step_end1: stepStatus === 5 }]" style=""></div>
                <div class="step1_circle" :class="[{ step1_ani2: stepStatus === 1 }, { step2_ani2: stepStatus === 2 }, { step3_ani2: stepStatus === 3 }, { step4_ani2: stepStatus === 4 }, { step_end2: stepStatus === 5 }]" style=""></div>
                <div class="step1_circle" :class="[{ step1_ani3: stepStatus === 1 }, { step2_ani3: stepStatus === 2 }, { step3_ani3: stepStatus === 3 }, { step4_ani3: stepStatus === 4 }, { step_end3: stepStatus === 5 }]" style=""></div>
                <div class="step1_circle" :class="[{ step1_ani4: stepStatus === 1 }, { step2_ani4: stepStatus === 2 }, { step3_ani4: stepStatus === 3 }, { step4_ani4: stepStatus === 4 }, { step_end4: stepStatus === 5 }]" style=""></div>
                <div class="step1_circle" :class="[{ step1_ani5: stepStatus === 1 }, { step2_ani5: stepStatus === 2 }, { step3_ani5: stepStatus === 3 }, { step4_ani5: stepStatus === 4 }, { step_end5: stepStatus === 5 }]" style=""></div>
                <div :class="showContents ? 'show_contents_text' : 'un_show_contents_text'" style="position: absolute; bottom: 0; font-size: 14px;">
                    <div style="margin-bottom: 25px; color: #fff;">현재 나의 축구 포지션: {{ position === '' ? '없음' : position }}</div>
                    <div style="color: #fff;">{{ position === '' ? '아직 포지션을 찾지 않았어요' : '새로운 포지션을 찾아보세요' }}</div>
                </div>
                <div @click="next('start')" :class="showContents ? 'show_contents_text' : 'un_show_contents_text'" style="font-weight: 500; font-size: 14px; color: var(--color-main); background-color: #f5f5f5; position: absolute; bottom: -150px; width: 330px; height: 47px; border-radius: 22.5px; line-height: 47px; text-align: center;">시작</div>
            </div>
        </div>

        <div v-if="endAnimate" style="height:60px; display:flex; align-items: center;" :style="{ borderBottom: isShared ? '1px solid #f5f5f5' : '' }">
            <div v-if="isShared" style="display:flex; justify-content: center;height:40px; background-color: white;">
                <div style="flex:1; display:flex; align-items: center; " @click="prevBack">
                    <img :src="require('@/assets/images/mypage/ico-move.png')" style="width: 10px; transform: rotate(180deg);margin-left: 20px;">
                    <span style="font-size:14px; font-weight:500; margin-left:5px; color:#210F03;">결과보기</span>
                </div>
            </div>
            <div v-else style="padding: 20px; padding-left: 17px;">
                <div @click="step === 14 && isShared ? prevBack() : closeConfirm()"><img :src="require('@/assets/img/member_talk_x.png')" style="width:18px;"></div>
            </div>
            <div style="flex: 1;"></div>
            <div style="display: flex;">
                <div style="padding: 20px; padding-right: 0;">
                    <div v-if="isShared" @click="share" style="margin-right: 20px">
                        <img :src="require('@/assets/img/share_position.png')" style="width: 17px;">
                    </div>
                </div>
            </div>
            <!-- <div style="display:grid; place-items: center; flex:1;">
                <img :src="require('@/assets/title.png')" style="height:25px;">
            </div> -->
        </div>
        <div style="flex:1; display: flex; flex-direction: column; overflow-y: scroll;">
            <div v-if="step === 0 && endAnimate" style="padding:0px 15px;">
                <div style="text-align:center; margin-top:30px;color:#5f6cc3;">나에게 맞는 축구 포지션은?</div>
                <div style="text-align:center;margin-top:10px; font-size:37px; font-weight:900; color:#ff7703;">나의 포지션 찾기</div>
                <div class="first_explain_wrap" style="margin-top:35px;">
                    <div><img :src="require('@/assets/explain_clock.png')" style="width:45px;"></div>
                    <div style="margin-top:10px;font-size:13px;font-weight:bold;">검사는 오래 걸리지 않아요</div>
                </div>
                <div class="first_explain_wrap">
                    <div><img :src="require('@/assets/explain_ball.png')" style="height:45px;"></div>
                    <div style="margin-top:10px;font-size:13px;font-weight:bold;line-height:22px;">테스트 속 질문의 기준은 현재 혹은 과거 운동 경험<br>에서 느낀 본인의 능력치를 토대로 평가해주세요</div>
                </div>
                <div class="first_explain_wrap">
                    <div><img :src="require('@/assets/explain_rounds.png')" style="height:40px;"></div>
                    <div style="margin-top:10px;font-size:13px;font-weight:bold;line-height:22px;">정확한 결과 제공을 위해 가급적이면<br>확실한 정도에 체크해주세요</div>
                </div>
            </div>
            <div style="padding: 0 15px;" v-if="step > 0 && step < 13">
                <div style="height:16px; background-color: #f5f5f5; border-radius:4px;width:100%;position:relative; overflow:hidden;">
                    <div style="position:absolute; transition: 0.2s all; left:0px;background-color: var(--color-main);height: 100%;  border-radius:4px;" :style="{ width: parseInt((step) / 12 * 100) + '%' }"></div>
                </div>
            </div>
            <div style="" v-if="step > 0 && step < 13">
                <!-- <div style="margin-top: 62px; margin-bottom: 18px; text-align: center; font-weight: 700; font-size: 24px;">Q{{ step }}</div> -->
                <div style="padding:0px 20px; margin-top: 80px; min-height: 120px;">
                    <div v-html="sentence[step]" style=" font-size:20px; font-weight:500;line-height:28px;text-align:center;"></div>
                    <div v-if="step === 12" style="text-align: center; color: #808080; font-size: 14px; margin-top: 4px;">(양발이면 모두 선택)</div>
                </div>
                <div v-if="step !== 12" style="min-height: 250px; overflow: hidden; text-align: center;">
                    <div style="position:relative; white-space: nowrap;" v-for="index in 12" :key="index">
                        <img v-if="index === step && step !== 9" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_sub_img_ani_unactive${step}` : `step_sub_img_ani_active${step}`" :src="require(`@/assets/img/sub_step${step}.png`)" alt="">
                        <img v-if="index === step" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_img_ani_unactive${step}` : `step_img_ani_active${step}`" :src="require(`@/assets/img/step${step}.png`)" alt="">
                        <img v-if="index === step && (step === 4 || step === 6 || step === 7 || step === 8 || step === 11)" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_sub2_img_ani_unactive${step}` : `step_sub2_img_ani_active${step}`" :src="require(`@/assets/img/sub2_step${step}.png`)" alt="">
                        <img v-if="index === step && (step === 6 || step === 7 || step === 8)" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_sub3_img_ani_unactive${step}` : `step_sub3_img_ani_active${step}`" :src="require(`@/assets/img/sub3_step${step}.png`)" alt="">
                        <img v-if="index === step && (step === 6 || step === 7 || step === 8)" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_sub4_img_ani_unactive${step}` : `step_sub4_img_ani_active${step}`" :src="require(`@/assets/img/sub4_step${step}.png`)" alt="">
                        <img v-if="index === step && (step === 7 || step === 8)" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_sub5_img_ani_unactive${step}` : `step_sub5_img_ani_active${step}`" :src="require(`@/assets/img/sub5_step${step}.png`)" alt="">
                        <img v-if="index === step && (step === 7)" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_sub6_img_ani_unactive${step}` : `step_sub6_img_ani_active${step}`" :src="require(`@/assets/img/sub6_step${step}.png`)" alt="">
                    </div>
                </div>
                <!-- <div style="height:220px; margin-top:50px; display:grid; place-items: center;">
                    <img :src="images[step]" style="max-height: 200px; max-width:150px;">
                </div> -->
                <div style="width: 100%;">
                    <div style="display:flex;align-items: center; justify-content: space-between; padding: 0px 20px;" v-if="step > 0 && step < 12">
                        <div class="round_wrap" @click="setScore(5)">
                            <div class="round" style="width:50px; height:50px;"></div>
                            <div class="inner_round orange_background" :class="[scores[step] === 5 ? 'active' : '']"></div>
                            <!-- <div style="position:absolute; left:5px; top:65px;width:60px; font-weight: 500; font-size:16px; color: #101014;">그렇다</div> -->
                        </div>
                        <div class="round_wrap " @click="setScore(4)">
                            <div class="inner_round orange_background" :class="[scores[step] === 4 ? 'active' : '']"></div>
                            <div class="round" style="width:50px; height:50px;"></div>
                        </div>
                        <div class="round_wrap" @click="setScore(3)">
                            <div class="inner_round orange_background" :class="[scores[step] === 3 ? 'active' : '']"></div>
                            <div class="round" style="width:50px; height:50px; border-color:black;"></div>
                        </div>
                        <div class="round_wrap" @click="setScore(2)">
                            <div class="inner_round orange_background" :class="[scores[step] === 2 ? 'active' : '']"></div>
                            <div class="round blue" style="width:50px; height:50px;"></div>
                        </div>
                        <div class="round_wrap" @click="setScore(1)">
                            <div class="round blue" style="width:50px; height:50px;"></div>
                            <div class="inner_round orange_background" :class="[scores[step] === 1 ? 'active' : '']"></div>
                            <!-- <div style="position:absolute; left: 0px; top:65px;width:60px;  font-weight:500; font-size:16px; color:#101014">그렇지 않다</div> -->
                        </div>
                    </div>
                    <div v-if="step > 0 && step < 12" style="display: flex;width: 100%; justify-content: space-between; padding: 20px; font-weight: 500;">
                        <div>그렇다</div>
                        <div style="margin-right: -6px;">그렇지 않다</div>
                    </div>
                </div>
                <div style="display:flex; justify-content: center; gap: 68px; align-items: center; padding:20px;" v-if="step === 12">
                    <div style="text-align: center;" @click="setFootScore(1)">
                        <div style="margin-bottom: 16px; font-weight: 500; color: #ff9c4a;">왼발</div>
                        <div>
                            <img style="width: 90px;" :src="leftFoot ? require('@/assets/img/left_foot_on.png') : require('@/assets/images/mypage/left-foot.png')" alt="">
                        </div>
                    </div>
                    <div style="text-align: center;" @click="setFootScore(3)">
                        <div style="margin-bottom: 16px; font-weight: 500; color: #ff9c4a;">오른발</div>
                        <div>
                            <img style="width: 90px;" :src="rightFoot ? require('@/assets/img/right_foot_on.png') : require('@/assets/images/mypage/right-foot.png')" alt="">
                        </div>
                    </div>
                    <!-- <div class="round_wrap" @click="setScore(1)">
                        <div class="round" style="width:46px; height:46px;"></div>
                        <div class="inner_round orange_background" :class="[scores[step] === 1 ? 'active' : '']"></div>
                        <div style="position:absolute; left:50%;white-space: nowrap; top:65px; font-weight:500; font-size:16px; transform: translateX(-50%);">왼발</div>
                    </div>

                    <div class="round_wrap" @click="setScore(2)">
                        <div class="inner_round orange_background" :class="[scores[step] === 2 ? 'active' : '']"></div>
                        <div class="round" style="width:46px; height:46px; border-color:black;"></div>
                        <div style="position:absolute; left:50%; white-space: nowrap;top:65px; font-weight:500; font-size:16px; transform: translateX(-50%);">양발</div>
                    </div>

                    <div class="round_wrap" @click="setScore(3)">
                        <div class="round" style="width:46px; height:46px;"></div>
                        <div class="inner_round orange_background" :class="[scores[step] === 3 ? 'active' : '']"></div>
                        <div style="position:absolute; left:50%; white-space: nowrap; top:65px;  font-weight:500;font-size:16px; transform: translateX(-50%);">오른발</div>
                    </div> -->
                </div>
            </div>
            <!-- <div v-if="step === 13">
                <div style="padding:100px 0px; display:grid; place-items: center;">
                    <img :src="require('@/assets/myposition_loading.png')" style="width:100px;">
                </div>
                <div style="text-align:center; font-size:20px; font-weight:800; color:#2b2b2b;">열심히 분석중이에요</div>
            </div> -->
            <div style="flex: 1; overflow-y: scroll;" v-if="step === 14 && positions.length > 0">
                <!-- <div v-for="each, i in positions" :key="i"> -->
                <!-- <div v-if="i !== 0">
                        <div style="text-align:center; font-size:24px;padding:20px; color:#fe6100;">그외 포지션은?</div>
                        <div style="background-color:#fff4d2; height:15px;"></div>
                    </div> -->
                <MyPositionResult ref="pos" :originallyPosition='position' :showPosition="showPosition" :positionsArr="positions" :showResult="showResult" :fade1="fade1" :fade2="fade2" :fade3="fade3" :name="myName" :signal-close-detail="signalCloseDetail" :showResultStart="showResultStart"></MyPositionResult>
                <!-- </div> -->
                <!--<div style="text-align:center; background-color: #fff4d2; padding-bottom:20px;" @click="share">-->
                <!--<div style="height:36px; line-height:36px; width:200px; text-align:center; display:inline-block; color:white; font-weight:bold; border-radius:18px; background-color: #fe6100;">공유하기</div>-->
                <!--</div>-->
                <!-- <div style="background-color: #fff4d2;color: #907e7e; font-size: 14px;padding: 0px 10px; padding-bottom: 10px;line-height: 16px;">*상기 포지션 결과는 오병이어의 지적재산권법에 의해 보호 받으며 개인적 공유, 게시를 허락합니다. 단, 당사의 허락없는 전체 또는 일부의 상업적 무단도용 및 카피는 법적 제재를 받을 수 있습니다.</div> -->
                <!--적합한 포지션은 <span><b>{{ getResultPositions() }} </b></span>입니다.-->
            </div>
            <div style="height: 100px;" v-if="step === 14 && positions.length > 0 && showPosition">
                <div @click="confirmProfilePosition" style="font-size: 14px;" class="common_btn">내 프로필에 적용하기</div>
            </div>
        </div>
        <template v-if="step !== 14 && endAnimate">
            <div style="background-color: white;padding-bottom: 20px; padding-top: 20px;" v-if="step === 0">
                <div style="text-align:center;">
                    <div style="border-radius:15px; height:30px; line-height:30px; background-color:#ff7703; display:inline-block; width:150px;color:white; font-weight:bold;" @click="next">시작</div>
                </div>
            </div>
            <div style="background-color: #fff;padding-bottom: 20px; padding-top: 20px; display: flex; gap: 20px" v-if="step > 0 && step < 13">
                <div @click="prevStep" v-if="step >= 2" class="prev_btn">
                    <div>이전</div>
                </div>
                <div v-if="activeBtn || step === 12" style="text-align:center; flex: 1">
                    <div :class="step === 12 ? 'result_btn' : 'next_btn'" @click="next(null, scores[step + 1])">{{ step === 12 ? '결과 보기' : '다음' }}</div>
                </div>
            </div>
        </template>
        <CommonPopupFrame :isOpen="isConfirmPosition" :closeCompleteAction="closeModal" :change-height="positions.length >= 3 ? 80 : 60" :change-bottom="50">
            <div style="display:inline-block; margin: 0 auto; width:60px; height: 3px; background-color: lightgrey; margin-top:20px; border-radius:2px;"></div>
            <div @click="closeModal" style="margin-left: auto; margin-right: 20px;background-color:white;" class="circle">
                <img :src="require('@/assets/img/black_x_btn_new.png')" style="width: 17px;">
            </div>
            <div style="margin-left: 20px; font-weight: 500; font-size: 20px;">포지션 선택</div>
            <div @touchmove.stop="() => { }" style="margin-top: 0; flex: 1; overflow-y: scroll;" :class="selectPositionArr.length === 1 ? 'position_img_cont_one_result' : 'position_img_cont'">
                <div @click="setSelectPosition(each.position)" v-for="each, i in selectPositionArr" :key="i">
                    <div style="text-align: center; position: relative;">
                        <Transition name="fade">
                            <img style="width: 96px;" :src="selectPosition === each.position ? require('@/assets/img/select_position_on.png') : require('@/assets/img/select_position_off.png')" alt="">
                        </Transition>
                        <div :style="{ color: selectPosition === each.position ? '#fff' : '#606060' }" style="transition: all 0.3s; position: absolute; top: 40%; left: 50%; transform: translate(-50%, -50%); font-weight: 700; font-size: 20px;">{{ each.position }}</div>
                    </div>
                    <div style="text-align: center; font-size: 14px; font-weight: 500; margin-top: 10px;">{{ Util.Mercenary.positionToString(each.position) }}</div>
                </div>
            </div>
            <div>
                <div @click="selectPositionComplete" class="common_btn_round">선택 완료</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>

import axios from "axios";
import MyPositionResult from "../common/MyPositionResult";
import { CommonPopupFrame } from "@/components/modal/my"
import Util from "../../modules/util";
import { SOCCER_HOW_TYPE } from "../../Constants";
import ResponseCode from "../../ResponseCode";
import moment from 'moment'

export default {
    name: "MyPosition",
    components: { MyPositionResult, CommonPopupFrame },
    props: {
        completeAction: {
            type: Function,
            default: () => { }
        },
        position: {
            type: String,
            default: ''
        },
        savedScores: {
            type: Array,
            default: () => { }
        }
    },
    computed: {
        Util() {
            return Util
        },
        isSoccerhowWrite() {
            return this.$GlobalStore.isSoccerhowWrite()
        },
        isOpenChatWrite() {
            return this.$GlobalStore.isOpenChatWrite()
        }
    },
    watch: {
        isSoccerhowWrite(newVal) {
            if (newVal) {
                this.animationStart()
            }
        },
        isOpenChatWrite(newVal) {
            if (newVal) {
                this.animationStart()
            }
        }
    },
    data() {
        return {
            Uitl: Util,
            // step: 11,
            step: 0,
            isShowProModal: false,
            SOCCER_HOW_TYPE: SOCCER_HOW_TYPE,
            endAnimate: false,
            showPosition: false,
            stepStatus: 1,
            isConfirmPosition: false,
            feedBackContents: '좋은 (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)을 가지셨군요. (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)을 더 키울 수 있는 약간의 피드백만 드려도 괜찮겠어요!',
            selectPosition: '',
            sentence: [
                '',
                '나는 날렵하며,<br> 달리기가 빠른 편이다.',
                '나는 호기심이 많으며, 도전을<br> 걸어보거나 모험을 하는 것을 즐긴다.',
                '나는 내가 하는 행동의 결과를 믿고,<br>실패에 대한 두려움이 없는 등,<br>자신감이 높은 편이다.',
                '나는 경기를 끝까지 뛸 수 있을 정도로<br>기초 체력이 좋은 편이다.',
                '나는 동료를 잘 챙기고, 골 양보를 하는 등<br>배려심이 있는 편이다.',
                '나는 공에 대한 감각이 좋으며,<br>볼 컨트롤이나 드리블 능력이 좋다.',
                '나는 섬세한 편이며,<br>패스와 크로스, 킥 등 볼 전달<br> 능력이 좋은 편이다.',
                '나는 시야가 넓은 편이며,<br>빈공간이나 기회를 잘 옅볼 수 있다.',
                '나는 문제상황 혹은 기회를 잘 파악할<br> 수 있으며 경기의 흐름을 잘 읽는다.',
                '나는 내가 맡은 역할에 대해<br>애정과 책임감을 가지고 임하는 편이며,<br>내 포지션의 역할을 놓치지 않고 수행한다.',
                '나는 내 주변에서나<br>내가 속한 팀에서 키가 큰 편이다.',
                '내가 주로 사용하는 발은?',
            ],
            images: [
                '',
            ],
            scores: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
            positions: [
                // {desc : "CB", position : "CB"},
                // {desc : "SS", position : "SS"},
            ],
            selectPositionArr: [
                // {position: "RWF"}
            ],
            savePositions: [],
            activeBtn: false,
            fade1: false,
            fade2: false,
            fade3: false,
            isShared: false,
            showContents: false,
            top: false,
            saveLeft: '',
            saveIndex: -1,
            signalCloseDetail: false,
            leftFoot: false,
            rightFoot: false,
            footScore: 0,
            toggleProModal: () => { },
            myName: null,
            position_result_history_group_key : null,
        }
    },
    methods: {
        findPositionPro() {
            this.$GlobalStore.closeSpliceModal('FindPositionStart')
            this.$GlobalStore.addModal('FindPositionProStart', { originallyPosition: this.$GlobalStore.loginInfo().position })
        },
        showResultStart() {
            this.toggleProModal = setTimeout(() => {
                this.isShowProModal = true
            }, 15000)
        },
        closeProModal() {
            this.isShowProModal = false
        },
        prevStep() {
            if (this.scores[this.step] === 0) {
                this.activeBtn = true
            }
            this.step--
        },
        async selectPositionComplete() {
            if (this.selectPosition === '') {
                this.$GlobalStore.showAlert('포지션을 선택해주세요.');
                return;
            }

            if (this.$GlobalStore.loginInfo().position_pro_ability !== null) {
                this.$GlobalStore.showConfirm('<strong style="color: #101014; margin-bottom: 6px; display: inline-block;">포지션 찾기 PRO로 찾은 포지션이 있어요</strong><br>해당 포지션을 선택하면 포지션 찾기 PRO로<br>찾은 포지션은 사라지게 됩니다.<br>정말로 이 포지션을 프로필에 적용할까요?', () => {
                    this.savePositionFunc()
                }, '적용하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION2)
            } else {
                this.savePositionFunc()
            }
        },
        async savePositionFunc() {
            this.$GlobalStore.showProgress();
            this.isConfirmPosition = false;

            const parameters = {};
            parameters.position = this.selectPosition;
            parameters.is_direct_position = 0;
            if(this.position_result_history_group_key) parameters.position_result_history_group_key = this.position_result_history_group_key;

            const res = await this.$Axios.post('/api/position/save', parameters);

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                const now = moment()
                const saveTime = now.format('YYYY-MM-DD HH:mm:ss')
                localStorage.setItem('savePositionTime', saveTime)
                localStorage.removeItem('savePositionTimePro')
                localStorage.removeItem('POSITION_TYPE')
                localStorage.removeItem('positionArr')
                localStorage.removeItem('groupData')
                localStorage.removeItem('scores')
                setTimeout(() => {
                    this.$GlobalStore.hideProgress()
                    // this.$GlobalStore.showProModal()
                    this.$GlobalStore.closeModalAll()
                    // this.$GlobalStore.addModal('ProfileMain', { mode: MY_VIEW_MODE.ME, memberIdx: this.$GlobalStore.loginInfo().idx })
                    this.$router.push({ path: '/view/my' + '?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
                }, 1200);
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        setSelectPosition(position) {
            if (this.selectPosition === position) {
                this.selectPosition = ''
            } else {
                this.selectPosition = position
            }
        },
        confirmProfilePosition() {
            this.isConfirmPosition = true
        },
        closeModal() {
            this.isConfirmPosition = false
        },
        async completeAndWait() {
            const formData = new FormData()
            formData.append('type', 'lite')

            await this.$Axios.post('/api/position/wait/save', formData)

        },
        next(v, step) {
            if (v === 'start') {
                this.endAnimate = true
            }
            if (step === 0) {
                this.activeBtn = false
            }
            if (this.step > 0 && this.step < 13 && !this.validate()) {
                this.$GlobalStore.showAlert('항목을 선택해주세요.');
                return;
            }

            if (this.step === 12) {
                const myScores = JSON.stringify(this.scores)
                const now = moment()
                const saveTime = now.format('YYYY-MM-DD HH:mm:ss')
                const positionType = { lite: true, pro: false }
                localStorage.setItem('initPositionTime', saveTime)
                localStorage.setItem('scores', myScores)
                localStorage.setItem('POSITION_TYPE', JSON.stringify(positionType))
                this.$GlobalStore.showProgress()
                this.completeAndWait()
                setTimeout(() => {
                    this.$GlobalStore.hideProgress()
                    this.$GlobalStore.closeLastModal()
                    this.$GlobalStore.addModal('PositionResultDelay', { isFromResult: true })
                }, 1500);
                return
            }

            this.step++;

            if (this.step === 14) {
                setTimeout(() => {
                    this.fade1 = true
                }, 100);

                setTimeout(() => {
                    this.fade2 = true
                }, 1500);

                setTimeout(() => {
                    this.fade3 = true
                }, 3000);
            }
        },
        prevBack() {
            this.signalCloseDetail = !this.signalCloseDetail;
            this.showPosition = false;
            this.isShared = false;
            this.positions = this.savePositions
            clearTimeout(this.toggleProModal)
        },
        // closeFindPosition() {
        //     if(this.step === 14 && !this.isShared){
        //         this.closeConfirm();
        //     }else {
        //         this.$GlobalStore.closeSpliceModal('FindPositionStart')
        //     }
        // },
        closeConfirm() {
            if (this.step === 14 && !this.isShared) {
                this.$GlobalStore.showConfirm('<strong style="color: #101014; margin-bottom: 6px; display: inline-block;">뒤로가기</strong><br>포지션 찾기를 진행중입니다.<br>중단하고 뒤로 이동할까요?<br>*지금까지의 내용은 저장되지 않습니다.', async () => {
                    this.$GlobalStore.closeLastModal();
                }, '뒤로 가기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION2);
            } else if (this.step === 14 && this.isShared) {
                this.prevBack();
            } else {
                this.$GlobalStore.closeSpliceModal('FindPositionStart')
            }
        },
        setScore(score, foot = false) {
            if (this.scores[this.step] === score) {
                this.$set(this.scores, this.step, 0)
            } else {
                this.$set(this.scores, this.step, score);
            }
            if (!foot && this.scores[this.step] !== 0) {
                this.activeBtn = true
            } else if (!foot && this.scores[this.step] === 0) {
                this.activeBtn = false
            }
        },
        setFootScore(score) {
            if (score === 1) {
                this.leftFoot = !this.leftFoot
            } else if (score === 3) {
                this.rightFoot = !this.rightFoot
            }

            if (this.leftFoot && this.rightFoot) {
                this.footScore = 2
            } else if (this.rightFoot) {
                this.footScore = 3
            } else if (this.leftFoot) {
                this.footScore = 1
            } else {
                this.footScore = 0
            }

            this.setScore(this.footScore, true)
        },
        validate() {
            if (this.scores[this.step] === 0) return false;
            return true;
        },
        async submit() {
            // 1 하(그렇지않다) 2 중하 3 중 4 중상 5 상(그렇다)
            let scores; //1문항부터 12개. 12번째 1 왼발, 2 양발 3 오른발
            if (this.savedScores) {
                scores = this.savedScores.splice(1, 12)
            } else {
                scores = this.scores.splice(1, 12);
            }
            // const scores = [4, 4, 2, 3, 1, 1, 2, 5, 5, 4, 3, 1]
            // const scores = [3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1]
            try {
                const res = await axios.get('/api/positionCheck/' + scores.join(','));
                if (res.data.code != 0) {
                    throw res.data.message;
                }
                this.positions = res.data.data;
                this.position_result_history_group_key = res.data.group_key;

                this.positions.forEach((item) => {
                    switch (item.desc) {
                        case 'WF':
                            this.selectPositionArr.push({ position: "RWF" })
                            this.selectPositionArr.push({ position: "LWF" })
                            break;
                        case 'WM':
                            this.selectPositionArr.push({ position: "RM" })
                            this.selectPositionArr.push({ position: "LM" })
                            break;
                        case 'WB':
                            this.selectPositionArr.push({ position: "RWB" })
                            this.selectPositionArr.push({ position: "LWB" })
                            break;
                        case "FB":
                            this.selectPositionArr.push({ position: "RB" })
                            this.selectPositionArr.push({ position: "LB" })
                            break;
                        default: this.selectPositionArr.push({ position: item.position })
                    }
                })
            } catch (e) { alert("포지션 확인중 오류가 발생 했습니다 : " + e.message); }
            let savedPosition = '';
            if (this.positions.length > 0) savedPosition = this.positions[0].desc;
            this.completeAction(savedPosition);
            this.next();
        },
        showResult(left, i) {
            this.savePositions = [...this.positions]
            this.saveLeft = left
            this.saveIndex = i
            // this.positions = this.positions.filter(item => item.desc !== desc)
            this.isShared = true
            this.showPosition = true
        },
        getResultPositions() {
            let result = "";
            for (let k in this.positions) {
                const item = this.positions[k];
                result += `${item.position} (${item.desc}), `
            }
            return result;
        },
        async share() {
            const message = '';
            const res = await this.$Axios.get('/api/share/position/url');
            const url = res.data.url;
            const device = this.$cookies.get('device');
            if (device === 'android') {
                const text = (message === "" ? "" : message + "\n") + url;
                window.Android.shareUrl(text);
            } else if (device === 'ios') {
                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({ cmd: 'shareUrl', text: message, url: url });
            }
        },
        async checkSoccerHowWrite() {
            const res = await this.$Axios.get('/api/soccerhow/check/written');
            if (!res.data.isSoccerhowWritten && this.$GlobalStore.loginInfo().is_coach == '0') {
                if(['경기 뛰기', '용병 찾기', '멤버 모집하기', '축구팀 찾기'].indexOf(this.$GlobalStore.loginInfo().visit_reason) > -1){
                    this.$GlobalStore.addModal('PopupBeforePositionPro', { transitionName: '', isModalBackTransparent: true })
                }
            }
        },
        animationStart() {
            setTimeout(() => {
                this.stepStatus = 2
            }, 1000);

            setTimeout(() => {
                this.stepStatus = 3
            }, 1900);

            setTimeout(() => {
                this.stepStatus = 4
            }, 2800);

            setTimeout(() => {
                this.stepStatus = 5
            }, 3700);


            setTimeout(() => {
                this.showContents = true
            }, 4500);
        }
    },
    created() {
        if (this.savedScores) {
            this.step = 13
            this.submit()
            this.endAnimate = true
            return
        }
        this.myName = this.$GlobalStore.loginInfo().name
        for (let i = 1; i <= 12; i++) {
            let number = '';
            if (i < 10) {
                number += '0';
            }
            number += '' + i;
            this.images.push(require('@/assets/myposition_question' + number + '.png'))
        }

        // 하우 글쓰기 체크
        if (this.$GlobalStore.loginInfo().is_coach == '0') {
            this.checkSoccerHowWrite();
        }
        if (this.isSoccerhowWrite || this.$GlobalStore.loginInfo().is_coach == '1') {
            this.animationStart()
        }


        // TODO MyPositionResult.vue 테스트 용
        // this.endAnimate = true;
        // this.step = 14;
        // this.showPosition = false;
        // this.positions = [
        //     {desc : "CF", position : "CF"},
        //     {desc : "FB", position : "LB"},
        //     {desc : "DM", position : "DM"}
        // ];
        //
        // this.fade1 = true
        // this.fade2 = true
        // this.fade3 = true

        const forceCloseConfirm = () => {
            setTimeout(() => {
                this.$GlobalStore.addPopFlag(forceCloseConfirm);
                this.closeConfirm();
            }, 0)
        };

        this.$GlobalStore.addPopFlag(forceCloseConfirm);

    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
    color: #101014;
}

.pro_modal_btn {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: red;
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: #fff;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 9.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.position_img_cont {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: center;
    margin-top: 70px;
    gap: 40px;
    flex: 1;
    align-items: center;
    padding: 40px;
}

.position_img_cont_one_result {
    display: flex;
    justify-content: center;
    margin-top: 70px;
    gap: 40px;
    flex: 1;
    align-items: center;
    padding: 40px;
}

.common_btn {
    width: calc(100% - 40px);
    line-height: 50px;
    text-align: center;
    background-color: #f5f5f5;
    border-radius: 12px;
    color: var(--color-main);
    margin: 0 auto;
    margin-top: 20px;
    font-weight: 700;
    font-size: 14px;
}

.common_btn_round {
    margin: 0 auto;
    font-weight: 500;
    font-size: 20px;
    width: 240px;
    height: 47px;
    border-radius: 22.5px;
    line-height: 47px;
    border: 1px solid var(--color-main);
    text-align: center;
}

.on_bg_cl {
    background: linear-gradient(180deg, #FFDFCA 0%, #FFFFFF 64%);
}

.step1 {
    width: 325px;
    transform: scale(3.5);
    transition: transform 0.5s
}

.step2 {
    width: 325px;
    transform: scale(2.1);
    transition: transform 0.5s
}

.step3 {
    width: 325px;
    transform: scale(1.7);
    transition: transform 0.5s
}

.step4 {
    width: 325px;
    transform: scale(1);
    transition: transform 0.5s
}

.step5 {
    transform: rotate(90deg);
    width: 203px;
    transition: transform 1s, width 1s, top 1s;
}

.show_contents {
    transform: translateY(-112px) rotate(90deg);
    width: 203px;
    transition: transform 1s, width 1s, top 1s;
}

.show_contents_text {
    opacity: 1;
    transition: opacity .5s
}

.un_show_contents_text {
    opacity: 0;
}

.step1_ani1 {
    right: 17%;
    top: 42%;
}

.step1_ani2 {
    right: 53%;
    top: -53%;
}

.step1_ani3 {
    right: 117%;
    top: 220px;
}

.step1_ani4 {
    right: -56%;
    top: 186%;
}

.step1_ani5 {
    right: 33%;
    top: 223%;
}

.step1_ball {
    width: 28px;
    height: 31px;
    top: 30%;
    right: 39%;
}

.step2_ani1 {
    top: 20%;
    right: 2%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ani2 {
    top: -22%;
    right: 63%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ani3 {
    top: 50%;
    right: 95%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ani4 {
    top: 91%;
    right: -38%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ani5 {
    top: 143%;
    right: 35%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ball {
    width: 28px;
    top: -3%;
    right: 72%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.6);
}

.step3_ani1 {
    top: -44%;
    right: -17%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ani2 {
    top: -22%;
    right: 63%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ani3 {
    top: 22%;
    right: 106%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ani4 {
    top: 27%;
    right: -38%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ani5 {
    top: 96%;
    right: 35%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ball {
    width: 28px;
    top: -47%;
    right: 5%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step4_ani1 {
    top: -13%;
    right: 9%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end1 {
    top: -13%;
    right: 9%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ani2 {
    top: -4%;
    right: 38%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end2 {
    top: -4%;
    right: 38%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ani3 {
    top: 11%;
    right: 76%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end3 {
    top: 11%;
    right: 76%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ani4 {
    top: 22%;
    right: -20%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end4 {
    top: 22%;
    right: -20%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ani5 {
    top: 75%;
    right: 30%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end5 {
    top: 75%;
    right: 30%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ball {
    width: 28px;
    top: -83%;
    right: 46%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end_ball {
    width: 28px;
    top: -83%;
    right: 46%;
    opacity: 0;
    transition: top 1s, right 1s, transform 1s, opacity 1s;
    transform: scale(0.3);
}


.step1_circle {
    height: 60px;
    width: 60px;
    background-color: #FFCCAA;
    border-radius: 50%;
    /* box-shadow: 0px 4px 4px 0px #00000040; */
    position: absolute;
}

.first_explain_wrap {
    padding: 15px 10px 20px 10px;
    text-align: center;
    background-color: #ffece1;
    border-radius: 5px;
}

.first_explain_wrap+.first_explain_wrap {
    margin-top: 10px;
}

.circle {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    box-shadow: 0px 1px 5px 0px #00000040;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.round_wrap {
    position: relative;
    font-size: 0px;
}

.round {
    border-radius: 50%;
    /* box-shadow: 0px 4px 4px 0px #10101440; */
    background: #ededed;
}

.round_wrap+.round_wrap {
    margin-left: 21px;
}


.inner_round {
    width: 100%;
    height: 100%;
    display: none;
    background-color: blue;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background-image: url('~@/assets/img/check_white.png');
    background-repeat: no-repeat;
    background-size: 22px;
    background-position: center center;
}


.orange_background {
    background-color: #ff7703;
}

.blue_background {
    background-color: #5f6cc3;
}

.inner_round.active {
    display: block;
}

.black_background {
    background-color: black;
}

.next_btn {
    border-radius: 12px;
    height: 40px;
    background-color: #ededed;
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(100% - 20px);
    color: white;
    font-weight: 500;
    margin: 0 auto;
    color: var(--color-main);
    font-size: 14px;
}

.result_btn {
    border-radius: 12px;
    height: 40px;
    background-color: #ededed;
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(100% - 20px);
    color: #d9d9d9;
    font-weight: 500;
    margin-right: 20px;
    color: var(--color-main);
    font-size: 14px;
}

.prev_btn {
    flex-basis: 102px;
    height: 40px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    float: left;
    margin-left: 20px;
    font-size: 14px;
    background-color: #ededed;
    font-weight: 500;
}

/* 스탭 원 */
.step_img_ani_unactive1 {
    transform: translateX(-60px)
}

.step_img_ani_active1 {
    transform: translateX(-44px)
}

.step_sub_img_ani_unactive1 {
    transform: translate(10px, -24px);
    width: 121px;
    height: 161px;
}

.step_sub_img_ani_active1 {
    transform: translate(40px, -24px);
    width: 171px;
    height: 161px;
}

/* 스탭 투 */
.step_img_ani_unactive2 {
    transform: translateX(12px) scale(1);
}

.step_img_ani_active2 {
    transform: translateX(-20px) scale(1.15);
}

.step_sub_img_ani_unactive2 {
    transform: translate(64px, 8px);
    width: 0px;
}

.step_sub_img_ani_active2 {
    transform: translate(64px, 8px);
    width: 50px;

}

/* 스탭 쓰리 */
.step_img_ani_unactive3 {
    transform: translateX(-83px) scale(0.85);
}

.step_img_ani_active3 {
    transform: translateX(-82px) scale(0.95);
}

.step_sub_img_ani_unactive3 {
    transform: translate(52px, -122px);
    opacity: 0;
}

.step_sub_img_ani_active3 {
    transform: translate(52px, -122px);
    opacity: 1;

}

/* 스텝 포 */
.step_img_ani_unactive4 {
    transform: translateX(0);
}

.step_img_ani_active4 {
    transform: translateX(30px);
}

.step_sub_img_ani_unactive4 {
    transform: translate(147px, 75px);
}

.step_sub_img_ani_active4 {
    transform: translate(176px, 77px) rotate(3deg);

}

.step_sub2_img_ani_unactive4 {
    transform: translate(-135px, 43px);
}

.step_sub2_img_ani_active4 {
    transform: translate(-97px, 53px) rotate(-20deg);

}

/* 스탭 파이브 */

.step_img_ani_unactive5 {
    transform: translateX(-35px);
}

.step_img_ani_active5 {
    transform: translateX(-35px) scale(0.8);
}

.step_sub_img_ani_unactive5 {
    transform: translate(92px, -110px);
    position: relative;
    z-index: 10;
}

.step_sub_img_ani_active5 {
    transform: translate(86px, -110px) rotate(-17deg) scale(0.7);
    position: relative;
    z-index: 10;

}

/* 스탭 씩스 */
.step_img_ani_unactive6 {
    transform: translateX(69px);
}

.step_img_ani_active6 {
    transform: translateX(69px) scale(1.1);
}

.step_sub_img_ani_unactive6 {
    transform: translate(144px, 11px);
    opacity: 0;
}

.step_sub_img_ani_active6 {
    transform: translate(144px, 11px);
    position: relative;
    z-index: 10;
    opacity: 1;
}

.step_sub2_img_ani_unactive6 {
    transform: translate(-156px, -1px);
}

.step_sub2_img_ani_active6 {
    transform: translate(-99px, -1px) scale(1.1);
    position: relative;
    z-index: 10;

}

.step_sub3_img_ani_unactive6 {
    transform: translate(-70px, 63px);
}

.step_sub3_img_ani_active6 {
    transform: translate(-60px, 70px) scale(1.1) rotate(-10deg);

}

.step_sub4_img_ani_unactive6 {
    transform: translate(-218px, 44px);
}

.step_sub4_img_ani_active6 {
    transform: translate(-233px, 41px) rotate(36deg);
}

/* 스탭 세븐 */
.step_img_ani_unactive7 {
    transform: translate(92px, 15px);
}

.step_img_ani_active7 {
    transform: translate(96px, 11px);
}

.step_sub_img_ani_unactive7 {
    transform: translate(254px, -13px);
    opacity: 0;
}

.step_sub_img_ani_active7 {
    transform: translate(254px, -13px);
    opacity: 1;
}

.step_sub2_img_ani_unactive7 {
    transform: translate(-11px, 77px);
}

.step_sub2_img_ani_active7 {
    transform: translate(-11px, 70px) rotate(9deg);
    position: relative;
    z-index: 10;

}

.step_sub3_img_ani_unactive7 {
    transform: translate(-99px, -62px);
}

.step_sub3_img_ani_active7 {
    transform: translate(-96px, -70px) rotate(20deg)
}

.step_sub4_img_ani_unactive7 {
    transform: translate(-36px, -76px);
}

.step_sub4_img_ani_active7 {
    transform: translate(-28px, -73px) rotate(17deg);
}

.step_sub5_img_ani_unactive7 {
    transform: translate(-135px, 14px);
    position: relative;
    z-index: 10;
}

.step_sub5_img_ani_active7 {
    transform: translate(-103px, 3px) rotate(-20deg);
    position: relative;
    z-index: 10;
}

.step_sub6_img_ani_unactive7 {
    transform: translate(-172px, -10px);
}

.step_sub6_img_ani_active7 {
    transform: translate(-82px, -37px);
}

/* 스탭 에잇 */
.step_img_ani_unactive8 {
    transform: translate(64px, 20px);
}

.step_img_ani_active8 {
    transform: translate(64px, 0px);
}

.step_sub_img_ani_unactive8 {
    transform: translate(31px, 5px);
    /* opacity: 0; */
}

.step_sub_img_ani_active8 {
    transform: translate(31px, 5px);
    opacity: 1;
}

.step_sub2_img_ani_unactive8 {

    transform: translate(56px, -12px);
    position: relative;
    z-index: 10;
}

.step_sub2_img_ani_active8 {
    transform: translate(-104px, -12px);
    position: relative;
    z-index: 10;

}

.step_sub3_img_ani_unactive8 {
    transform: translate(42px, -18px);
}

.step_sub3_img_ani_active8 {
    transform: translate(29px, -18px) rotate(40deg);

}

.step_sub4_img_ani_unactive8 {
    transform: translate(20px, -13px);
}

.step_sub4_img_ani_active8 {
    transform: translate(20px, -13px);
}

.step_sub5_img_ani_unactive8 {
    transform: translate(18px, 38px);
    position: relative;
    z-index: 10;
}

.step_sub5_img_ani_active8 {
    transform: translate(-16px, 38px);
    position: relative;
    z-index: 10;
}

/* 스텝 나인 */
.step_img_ani_unactive9 {
    transform: rotateX(0deg);
}

.step_img_ani_active9 {
    transform: rotateX(60deg);
}

/* 스텝 탠 */

.step_img_ani_unactive10 {
    transform: translate(-25px);
}

.step_img_ani_active10 {
    transform: translate(-25px);
}

.step_sub_img_ani_unactive10 {
    transform: translate(18px, -94px);
    position: relative;
    z-index: 10;
}

.step_sub_img_ani_active10 {
    transform: translate(25px, -102px) rotate(-34deg);
    position: relative;
    z-index: 10;
}

/* 스텝 일레븐 */

.step_img_ani_unactive11 {
    transform: translate(45px, 60px) scale(0.9);
    position: relative;
    z-index: 15;
}

.step_img_ani_active11 {
    transform: translate(45px, 66px) scale(1);
    position: relative;
    z-index: 10;
}

.step_sub_img_ani_unactive11 {
    transform: translate(107px, -71px);
    position: relative;
    z-index: 10;
}

.step_sub_img_ani_active11 {
    transform: translate(98px, -82px);
    position: relative;
    z-index: 15;
}

.step_sub2_img_ani_unactive11 {
    transform: translate(-46px, -43px);
    position: relative;
    z-index: 5;
}

.step_sub2_img_ani_active11 {
    transform: translate(-71px, -59px) rotate(34deg);
    position: relative;
    z-index: 5;
}
</style>import { log10 } from "core-js/core/number";
import { get } from "lodash";

